var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "line",
    d: "M1.82344 9.00419L9.64545 1.1822C9.91586 0.911741 9.91586 0.473267 9.64545 0.202812C9.37495 -0.0675609 8.93652 -0.0675609 8.66606 0.202812L0.354361 8.5145C0.0839873 8.78496 0.0839873 9.22343 0.354361 9.49388L8.66606 17.8056C8.94123 18.0713 9.3797 18.0637 9.64545 17.7885C9.90466 17.5201 9.90466 17.0946 9.64545 16.8262L1.82344 9.00419Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.e5eb1dc1.svg";
export { ForwardRef as ReactComponent };